<!-- 文章详情页 -->
<template>
  <div>
    <my-header></my-header>
    <designDel :id="Id" :sourceType="sourceType"></designDel>
    <my-footer></my-footer>
  </div>
</template>
<script>
import designDel from "../common/designDel"
import {createBrowse} from "../../assets/js/modules/articleApi"
export default {
  components: {
     designDel,

  },
  data() {
    return {
      Id: 1,
      sourceType:"",
      userInfo:"",
      userId:"",
    }
  },
  created() {
    this.Id = this.$route.query.id;
     this.sourceType = this.$route.query.sourceType;
     this.getUserInfo();
     this.createActicle();
    // console.log(this.$route.query)
  },
  methods:{
    createActicle(){
      let data={
        SourceID:this.Id,
        UserID: this.userId,
        SourceType: 2, //（1：文件、2：文章、3：评论）
      }
      createBrowse(data).then(res=>{
        if(res.data.Code == 1){
          console.log("已浏览");
        }else{
          console.log("报错啦")
        }
      })
    },
     getUserInfo() { //获取用户信息
      if (JSON.parse(localStorage.getItem('userInfo'))) {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.userId = this.userInfo.Id;
      } else {
        this.userId = 0;
      }
    }
  },
  // watch: {
  //   $route(to, from) {
  //     this.uid = this.$route.query.uid;
  //     this.Id = this.$route.query.id;
  //   }
  // }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index/artDetail.vue